import React from 'react';
import { Checkbox } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/modules/checkbox.less';

export default Checkbox;
